import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { getIP } from 'src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service';

@Injectable({
  providedIn: 'root'
})
export class JobService {
  //api_url: string = 'http://192.168.0.158:4284/api/' + 'Requisition/';
  api_url = environment.SERVER_URL + 'icrweb/home/';

  jobList = new BehaviorSubject(null);


  constructor(
    private http: HttpClient
  ) { }

  getJobs(request) {
    return this.http.post(this.api_url + 'tallite_career_portal_job_detail', request);
  }

  applyForJob(request) {
    return this.http.post(this.api_url + 'tallite_career_portal_apply_job', request)

  }

  getMasters(params?) {
    if (!params) {
      try {
        let ip_details = getIP()
        params = {}
        params['ip'] = ip_details['ip'];
        params['sellerShortCode'] = environment.SHORTCODE;
      }
      catch (err) {

      }
    }
    else {
      params['sellerShortCode'] = environment.SHORTCODE;
    }
    return this.http.get(environment.SERVER_URL + 'icrweb/countryMaster', { params: params, headers: { header_type: '2' } })
  }
  savebookmark(details) {
    return this.http.post(this.api_url + 'save_job_to_favourites', details);
  }
}
